import { Component, EventEmitter, Input, Output } from '@angular/core';
import { Client, Course, Lesson } from '@mira-avant/mtlibs';
import { AngularModule } from '../../../../modules/angular.module';
import { NavigationService } from '../../../../services/navigation.service';
import { ClientService } from '../../../../services/client.service';
import { Subscription } from 'rxjs';
import { UnitBoxComponent } from '../unit-box/unit-box.component';
import { CourseTitleComponent } from '../course-title/course-title.component';
import { UnitTitleComponent } from '../unit-title/unit-title.component';
import { LessonTileComponent } from '../lesson-tile/lesson-tile.component';

@Component({
	selector: 'app-course',
	standalone: true,
	imports: [
		AngularModule,
		UnitBoxComponent,
		CourseTitleComponent,
		UnitTitleComponent,
		LessonTileComponent,
	],
	templateUrl: './course.component.html',
	styleUrl: './course.component.scss',
})
export class CourseComponent {
	@Output('onLessonSelected') public onLessonSelectedEmitter = new EventEmitter<Lesson>();
	@Input('course') public course: Course | undefined;
	public client: Client | undefined;
	private sub: Subscription | undefined;

	constructor(public nav: NavigationService, public clientService: ClientService) {
		this.sub = this.clientService.selectedClient$.subscribe(client => {
			this.client = client;
		});
	}

	public selectLesson(lesson: Lesson): void {
		this.onLessonSelectedEmitter.emit(lesson);
	}

	ngOnInit() {}

	ngOnDestroy() {
		this.sub?.unsubscribe();
	}
}
